import classNames from 'classnames'
import Link from 'next/link'
import { Fragment } from 'react'
import Card from 'react-bootstrap/Card'

import { ArticleType } from '@/types/home'
import { ArticleListEntryType } from '@/types/page'

import styles from './ArticlePreview.module.scss'

type Props = {
  article: ArticleType | ArticleListEntryType
  small?: boolean
  square?: boolean
}

const ArticlePreview = ({ article, small, square }: Props) => {
  const { author, date, excerpt, href, link, media, site, tags, title, value } = article

  const articleLink = link || href
  if (!articleLink) return null

  let authorName = author?.name
  if (site && site.id !== 'edhrec') {
    authorName += ` — ${site.name}`
  }

  return (
    <div className={styles.container}>
      <Card className={classNames('h-100 m-0 shadow-sm', { [styles.small]: small, 'rounded-0': square })}>
        {media && (
          <Link href={articleLink} prefetch={false}>
            <Card.Img
              alt={`Background image for ${title || value}`}
              className={classNames(styles.media, { 'rounded-0': square })}
              src={media}
              variant='top'
            />
          </Link>
        )}
        <Card.Body className='d-flex flex-column'>
          {author && author.avatar && media && (
            <Link href={author.link} prefetch={false}>
              <div className={styles.avatar}>
                <img alt={author.name} src={author.avatar} />
              </div>
            </Link>
          )}
          <div className='d-flex flex-column justify-content-between'>
            <div className={styles.body}>
              <div className='align-items-center d-flex justify-content-between'>
                <div className={styles.date}>{date}</div>
                <div className={styles.author}>
                  {author && (
                    <Link dangerouslySetInnerHTML={{ __html: authorName }} href={author.link} prefetch={false} />
                  )}
                </div>
              </div>
              <h5 className={styles.title}>
                <Link href={articleLink} prefetch={false}>
                  {title || value}
                </Link>
              </h5>
              <div className={styles.excerpt}>{excerpt}</div>
            </div>
            {tags && tags.length > 0 && (
              <div className='d-none d-md-block'>
                <hr />
                <div className={styles.tags}>
                  {tags.map(({ link, name }, i) => (
                    <Fragment key={link}>
                      <Link href={link} prefetch={false}>{`#${name}`}</Link>
                      {i !== tags.length - 1 && <span>, </span>}
                    </Fragment>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default ArticlePreview
